import { render, staticRenderFns } from "./SMSTextPreview.vue?vue&type=template&id=5102031c&scoped=true"
import script from "./SMSTextPreview.vue?vue&type=script&lang=js"
export * from "./SMSTextPreview.vue?vue&type=script&lang=js"
import style0 from "./SMSTextPreview.vue?vue&type=style&index=0&id=5102031c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102031c",
  null
  
)

export default component.exports